const lookupActionTypes = {
  SET_LOOKUP_DATA: 'SET_LOOKUP_DATA',
};
export default lookupActionTypes;
